import React from 'react';
import { NavigatorDetail } from '@/media/changeDomain';
import PropTypes from 'prop-types';
import * as Styles from '../InputDomain/InputDomain.styles';
import { TextField } from 'gatorcomponents';

const NavigatorInput = ({ handleChangeDomain, newDomain, mySiteLabel }) => (
  <>
    <NavigatorDetail />

    <Styles.TextFieldWrapper>
      <TextField
        label={mySiteLabel}
        onChange={handleChangeDomain}
        maxLength={63}
        value={newDomain.value}
        helpText={newDomain.error}
        status={newDomain.error ? 'error' : 'normal'}
        testId="inputDomain"
        disabled
      />
    </Styles.TextFieldWrapper>
  </>
);

NavigatorInput.propTypes = {
  handleChangeDomain: PropTypes.func,
  value: PropTypes.string,
  mySiteLabel: PropTypes.string,
  newDomain: PropTypes.object,
};

export default NavigatorInput;
